{
  "header": {
    "eyebrow": "Finance",
    "title": "Checklist",
    "description": "Before the monthly calculations: what changed in CPMS and IAM over the last two months, and what is not set up right."
  },
  "refresh": "Refresh",
  "loading": "Loading the checklist",
  "error": {
    "title": "Could not load the checklist",
    "description": "The identity service did not respond. Try again later."
  },
  "noAccess": {
    "title": "Domain access only",
    "description": "The checklist spans the whole fleet and is available to domain-level users only."
  },
  "card": {
    "error": {
      "title": "Could not run this check",
      "description": "The service behind it did not respond. Refresh to try again."
    },
    "columns": {
      "time": "Time",
      "action": "Action",
      "otherAction": "other",
      "type": "Type",
      "kind": "Kind",
      "locationId": "Location id",
      "partyId": "Id",
      "objectId": "Id",
      "description": "Description",
      "user": "User",
      "station": "Charging station",
      "model": "Model",
      "lastSeen": "Last seen",
      "location": "Location",
      "address": "Address",
      "split": "Split",
      "problem": "Problem",
      "figures": "Off by",
      "reason": "Problem",
      "cpms": "Open in CPMS",
      "checked": "Checked",
      "chargingPoints": "Charging points",
      "owners": "Owners and fees",
      "change": "Change",
      "chargeCard": "Charge card",
      "contractId": "Contract id",
      "token": "Token",
      "status": "Status",
      "driver": "Driver",
      "tenant": "Tenant",
      "client": "Client",
      "dataset": "Administration",
      "linkedTo": "Linked to"
    },
    "openInCpms": "Open {{id}} in CPMS",
    "checkedBy": "Checked by {{user}} on {{time}}",
    "tickRow": "Mark {{row}} as checked",
    "tickFailed": "Could not save the tick. Try again.",
    "change": {
      "created": "New",
      "modified": "Modified"
    },
    "dataset": {
      "billing": "Billing",
      "reimbursement": "Reimbursement"
    },
    "notLinked": "Not linked"
  },
  "checks": {
    "newLocations": {
      "title": "New locations",
      "description": "OCPI locations created in CPMS in the last two months.",
      "count": "{{count}} location",
      "count_other": "{{count}} locations",
      "empty": {
        "title": "No new locations",
        "description": "No OCPI location was created in the last two months."
      }
    },
    "newParties": {
      "title": "New tenants and organisations",
      "description": "Tenants and organisations created in IAM in the last two months.",
      "count": "{{count}} party",
      "count_other": "{{count}} parties",
      "kind": {
        "tenant": "Tenant",
        "organisation": "Organisation"
      },
      "empty": {
        "title": "No new tenants or organisations",
        "description": "Nothing was created in IAM in the last two months."
      }
    },
    "chargeCards": {
      "title": "New and changed charge cards",
      "description": "Charge cards created or modified in the MSP gateway in the last two months.",
      "count": "{{count}} charge card",
      "count_other": "{{count}} charge cards",
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      },
      "validUntil": "Valid until {{date}}",
      "empty": {
        "title": "No new or changed charge cards",
        "description": "No charge card was created or modified in the last two months."
      }
    },
    "drivers": {
      "title": "New and changed drivers",
      "description": "Drivers created or modified in the MSP gateway in the last two months.",
      "count": "{{count}} driver",
      "count_other": "{{count}} drivers",
      "empty": {
        "title": "No new or changed drivers",
        "description": "No driver was created or modified in the last two months."
      }
    },
    "weFactClients": {
      "title": "New and changed WeFact clients",
      "description": "Clients created or modified in WeFact (billing and reimbursement) in the last two months.",
      "count": "{{count}} client",
      "count_other": "{{count}} clients",
      "empty": {
        "title": "No new or changed clients",
        "description": "No WeFact client was created or modified in the last two months."
      }
    },
    "tariffChanges": {
      "title": "Location and tariff changes",
      "description": "Edits, moves and deletions of OCPI locations and tariffs in CPMS in the last two months.",
      "count": "{{count}} change",
      "count_other": "{{count}} changes",
      "type": {
        "location": "Location",
        "tariff": "Tariff"
      },
      "empty": {
        "title": "No changes",
        "description": "No location or tariff was changed in the last two months."
      }
    },
    "stationsWithoutLocation": {
      "title": "Charging stations without a location",
      "description": "Stations CPMS holds that are not placed at any location, so their sessions cannot be attributed.",
      "count": "{{count}} station",
      "count_other": "{{count}} stations",
      "empty": {
        "title": "Every station has a location",
        "description": "Nothing to fix here."
      }
    },
    "locationsWithoutTariff": {
      "title": "Locations without a tariff",
      "description": "Locations with no tariff, or with a tariff CPMS no longer resolves, so there is nothing to split or reimburse.",
      "count": "{{count}} location",
      "count_other": "{{count}} locations",
      "reason": {
        "none": "No tariff",
        "unresolved": "Unknown tariff"
      },
      "empty": {
        "title": "Every location has a tariff",
        "description": "Nothing to fix here."
      }
    },
    "splits": {
      "title": "Splits that no longer add up",
      "description": "Splits whose service fee and party cuts do not add up to the location's current CPMS price, or whose location or tariff CPMS no longer has. Checked live on every load.",
      "count": "{{count}} split",
      "count_other": "{{count}} splits",
      "status": {
        "Unbalanced": "Does not add up",
        "LocationMissing": "Location gone",
        "TariffMissing": "No tariff"
      },
      "figure": "{{component}}: price {{price}}, fee {{fee}}, parties {{allocated}}, left {{remaining}} {{unit}}",
      "components": {
        "energyPricePerKwh": "Energy",
        "chargingTimePricePerHour": "Charging",
        "parkingTimePricePerHour": "Parking",
        "flatFeePrice": "Flat fee"
      },
      "units": {
        "energyPricePerKwh": "€/kWh",
        "chargingTimePricePerHour": "€/h",
        "parkingTimePricePerHour": "€/h",
        "flatFeePrice": "€/session"
      },
      "empty": {
        "title": "Every split adds up",
        "description": "Nothing to fix here."
      }
    },
    "billingFees": {
      "title": "Locations with a billing fee problem",
      "description": "CPMS locations whose owners or billing fee do not look right: an owner without a billing fee (neither its own nor its tenant's), a fee of zero, no owner, several owners, or no charging points. Checked live on every load.",
      "count": "{{count}} location",
      "count_other": "{{count}} locations",
      "problem": {
        "FeeMissing": "No billing fee",
        "FeeZero": "Fee is zero",
        "NoOwner": "No owner",
        "MultipleOwners": "Several owners",
        "NoChargingPoints": "No charging points",
        "OwnersUnreadable": "Owners unreadable"
      },
      "owner": {
        "own": "{{owner}}: {{price}} per charging point",
        "tenant": "{{owner}}: {{price}} per charging point, from tenant {{tenant}}",
        "none": "{{owner}}: no billing fee"
      },
      "empty": {
        "title": "Every location is billed",
        "description": "Nothing to fix here."
      }
    }
  }
}
